import { frontendURL } from '../../../helper/URLHelper';

const CrmKanbanBoard = () => import('./CrmKanbanBoard.vue');
const CrmDashboard = () => import('./CrmDashboard.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_kanban',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CrmKanbanBoard,
  },
  {
    path: frontendURL('accounts/:accountId/crm/painel'),
    name: 'crm_dashboard',
    // An agent reaches the same screen scoped to their own numbers; the server
    // decides what they are allowed to see, not this list.
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CrmDashboard,
  },
];
